export default __webpack_public_path__ + "static/media/placeholder_store01-fr-mobile.a47b829d.png";